export const slotSelectionEventNames = {
  pageViewed: "slot selection page viewed",
  coursePicked: "course slot picked",
  scheduleConfirmed: "schedule confirmed",
  noSlotAvailable: "no slot available to select error",
  scheduleConfirmationViewed: "schedule confirmation page viewed",
  slotClosed: "slot selection closed",
  clickBackButton: "back button on slot selection confirmation flow clicked",
  nextButton: "next clicked on slot selection",
  startAgain: "start again on slot selection flow clicked",
  contactKakakSiaga: "contact kakak siaga clicked",
  slotSelectionSkipped: "slot selection skipped"
};
